import React from "react";
import Slider from "react-slick";
import NextImage from "next/image";
import styled from "styled-components";

import { Box, FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";

import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

function Symptoms(props) {
  const {
    data = [],
    isMobile = false,
    handleScrollToCallBackForm = () => {},
  } = props || {};
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: data?.benefits?.benefits?.length,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 5,
          dots: true,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          dots: true,
          infinite: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: false,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      {data?.benefits?.benefits.length > 0 && (
        <RedDiv flexDirection={"column"}>
          <FlexDom>
            <LHSDiv flexDirection={"column"}>
              <Typography
                variant="paragraph1"
                color={theme.colors.shadeRed}
                fontFamily={"var(--font-700)"}
              >
                {data?.benefits?.title}
              </Typography>
              {!isMobile && data?.benefits?.benefits_cta && (
                <FlexDiv mt={"14px"}>
                  <Button
                    variant={"primary"}
                    onClick={handleScrollToCallBackForm}
                    fontSize={"15px"}
                  >
                    {data?.benefits?.benefits_cta}
                  </Button>
                </FlexDiv>
              )}
            </LHSDiv>
            <RHSDiv>
              <Slider {...settings}>
                {data?.benefits?.benefits?.map((item, index) => {
                  return (
                    <Box key={index} px={"5px"}>
                      <FlexDiv
                        flexDirection={"column"}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <IconRing mb={"20px"}>
                          <NextImage
                            src={item.icon}
                            fill={true}
                            alt={item.title}
                            style={{ objectFit: "cover" }}
                          />
                        </IconRing>
                        <Typography
                          variant="link1"
                          fontSize="14px"
                          href={item.url}
                          target="_blank"
                          color={theme.colors.gray_100}
                          textAlign="center"
                        >
                          {item.title}
                        </Typography>
                      </FlexDiv>
                    </Box>
                  );
                })}
              </Slider>
            </RHSDiv>
          </FlexDom>
        </RedDiv>
      )}
    </>
  );
}

export default Symptoms;
const RedDiv = styled(FlexDiv)`
  background: ${theme.colors.linearGradRed};
  padding: 35px 0;
`;
const LHSDiv = styled(FlexDiv)`
  max-width: 250px;
  margin-right: 50px;
  @media only screen and (max-width: 992px) {
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 25px;
    align-items: center;
    text-align: center;
  }
`;
const RHSDiv = styled(FlexDiv)`
  flex: 1;
  max-width: 100%;
  min-width: 1px;
  .slick-slider {
    width: 100%;
    .slick-dots {
      li {
        &.slick-active {
          button {
            &::before {
              background-color: ${theme.colors.dotsColor};
            }
          }
        }
        button {
          position: relative;
          &::before {
            background-color: rgba(92, 92, 110, 0.2);
            border-radius: 50%;
            height: 8px;
            width: 8px;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }
  }
`;
const IconRing = styled(Box)`
  height: 78px;
  width: 78px;
  border-radius: 50%;
  background-color: ${theme.colors.shadeRed};
  overflow: hidden;
  position: relative;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  @media only screen and (max-width: 767px) {
    height: 66px;
    width: 66px;
  }
`;
const FlexDom = styled(FlexContainer)`
  @media only screen and (max-width: 992px) {
    flex-direction: column;
  }
`;
